import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SEOService } from 'src/app/shared/seo.service';

@Component({
  selector: 'app-index-blog',
  templateUrl: './index-blog.component.html',
  styleUrls: ['./index-blog.component.css']
})
export class IndexBlogComponent implements OnInit {
  navClass = 'bg-white';
  constructor(private seoService:SEOService) { }

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      900: {
        items: 1
      }
    },
    nav: false
  };

  ngOnInit(): void {
    this.setMeta();
  }

  setMeta() {
    var desc;
    var keys;
    var title

    keys = 'Pratiu öğretmenleri, öğretmenler';
    title = 'pratiu - Öğretmenler';
    desc = title;

    this.seoService.updateDescription(desc);
    this.seoService.updateKeywords(keys);
    this.seoService.updateTitle(title); 
  }

}
